module.exports = __webpack_public_path__ + "static/media/hall-PF.31b20cde.svg";